import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=cc214cda&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=cc214cda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc214cda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc214cda')) {
      api.createRecord('cc214cda', component.options)
    } else {
      api.reload('cc214cda', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=cc214cda&scoped=true&", function () {
      api.rerender('cc214cda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dM0N2CKKLRo0/JS/comp/PopupBox.vue"
export default component.exports